import { useState } from 'react';
import { fmt, fmtInt } from '../../lib/format';
import type { CalculatorResults } from '../../lib/types';

interface Props {
  results: CalculatorResults;
}

export function AmortizationCard({ results }: Props) {
  const [activeTab, setActiveTab] = useState<'yearly' | 'monthly'>('yearly');

  return (
    <div className="card">
      <div className="card-header">Amortization Schedule</div>
      <div className="tab-bar">
        <button
          className={activeTab === 'yearly' ? 'active' : ''}
          onClick={() => setActiveTab('yearly')}
        >
          Yearly
        </button>
        <button
          className={activeTab === 'monthly' ? 'active' : ''}
          onClick={() => setActiveTab('monthly')}
        >
          Monthly (Year 1)
        </button>
      </div>

      <div className={`tab-content${activeTab === 'yearly' ? ' active' : ''}`}>
        <div className="amort-table-wrap table-scroll-wrap">
          <table>
            <thead>
              <tr><th>Year</th><th>Principal</th><th>Interest</th><th>Balance</th></tr>
            </thead>
            <tbody>
              {results.yearlyAmortization.map(row => (
                <tr key={row.year}>
                  <td>{row.year}</td>
                  <td>${fmtInt(row.principal)}</td>
                  <td>${fmtInt(row.interest)}</td>
                  <td>${fmtInt(row.balance)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className={`tab-content${activeTab === 'monthly' ? ' active' : ''}`}>
        <div className="amort-table-wrap table-scroll-wrap">
          <table>
            <thead>
              <tr><th>Month</th><th>Payment</th><th>Principal</th><th>Interest</th><th>Balance</th></tr>
            </thead>
            <tbody>
              {results.monthlyAmortization.map(row => (
                <tr key={row.month}>
                  <td>{row.month}</td>
                  <td>${fmt(row.payment)}</td>
                  <td>${fmt(row.principal)}</td>
                  <td>${fmt(row.interest)}</td>
                  <td>${fmtInt(row.balance)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
